export { default as WebView } from "react-native-web-webview";
